import { useAuthStore } from '../index';
import { changeLocale } from '../index';
import { SUPPORTED_LOCALES } from '../index';
import { type Locale } from '../index';
import { toast } from '../index';
import { useTranslation } from 'react-i18next';
import { authEndpoints } from '../api/auth-endpoints';

/** Native select: the language changes at runtime and is saved in the profile when signed in. */
export function LanguageSelect() {
  const { t, i18n } = useTranslation();
  const status = useAuthStore((s) => s.status);
  const setMe = useAuthStore((s) => s.setMe);

  const onChange = async (locale: Locale) => {
    await changeLocale(locale);
    toast('info', t('core.language.changed', { language: t(`core.language.${locale}`) }));
    if (status === 'authenticated') {
      try {
        setMe(await authEndpoints.preferences({ locale }));
      } catch {
        /* the choice is kept locally anyway */
      }
    }
  };

  return (
    <select
      className="lang"
      aria-label={t('core.language.label')}
      value={i18n.language}
      onChange={(e) => void onChange(e.target.value as Locale)}
    >
      {SUPPORTED_LOCALES.map((locale) => (
        <option key={locale} value={locale}>
          {locale.toUpperCase()}
        </option>
      ))}
    </select>
  );
}
